/**
 * External dependencies
 */
export default class Preferences {
	constructor(cscom) {
		if (!(this instanceof Preferences)) {
			return new Preferences(cscom);
		}
		this.cscom = cscom;
	}

	getPreferences() {
        return this.cscom.req.get('/user-site-api/preferences');
	}

	savePreferences(preferences) {
        return this.cscom.req.put('/user-site-api/preferences', preferences).then((result) => {
			return result;
		});
	}

	getShopifyCollectionSortOrders() {
        return this.cscom.req.get('/user-site-api/shopify/collection-sort-orders');
    }

	getShopifyProductTypes() {
        return this.cscom.req.get('/user-site-api/shopify/product-types');
    }

	getShopifyCategoryOptions() {
        return this.cscom.req.get('/user-site-api/shopify/category-options');
    }
}
